import { ConsentLevel, ConsentLevels } from 'db-npm-e4sc-rd-ui';
import { ParserFunctionInterface } from '../../';
import { ContextSettings } from '../../../../../shared/hooks';
import { loadScriptOnce } from '../../../../utils/loadScriptOnce';

//TODO
// Support list type player

const EXT_SCRIPT_URL = 'https://play2.qbrick.com/qplayer/qplayer.min.js';
const QUERY_SELECTOR = '[data-module="video-snippet"]';

function hasGoBrain(): boolean {
  return typeof (window as Window & { GoBrain?: unknown }).GoBrain === 'object';
}

export type videoParserConfig = {
  accountId?: string;
  language?: string;
  sharing?: boolean;
  download?: boolean;
};

const defaultConfig: videoParserConfig = {};

function createPlayerElement(
  mediaId: string,
  accountId: string,
  language: string,
  sharing: boolean,
  download: boolean,
  analytics: boolean
): HTMLElement {
  const playerElement = document.createElement('qplayer-embed');
  playerElement.setAttribute('data-qplayer-media-id', mediaId);
  playerElement.setAttribute('data-qplayer-account-id', accountId);
  playerElement.setAttribute('data-qplayer-language', language);
  playerElement.setAttribute('data-qplayer-sharing', sharing.toString());
  playerElement.setAttribute('data-qplayer-download', download.toString());
  playerElement.setAttribute('data-qplayer-analytics', analytics.toString());
  playerElement.setAttribute('data-qplayer-autoplay', 'false');
  playerElement.setAttribute('data-qplayer-mute', 'false');
  playerElement.setAttribute('data-qplayer-aspect-ratio', '16/9');
  return playerElement;
}

let videoParser: ParserFunctionInterface;
videoParser = (
  el: any,
  config: videoParserConfig,
  cookieConsentLevels: ConsentLevels = [0],
  contextSettings: ContextSettings | undefined
) => {
  config = config ?? defaultConfig;
  const arrVideoEl = el.querySelectorAll(QUERY_SELECTOR);
  const accountId = config.accountId || contextSettings?.videoAccountId || '';
  const language = config.language || contextSettings?.language || 'en';
  const analytics = cookieConsentLevels.indexOf(ConsentLevel.Statistics) > -1;

  function init() {
    if (arrVideoEl.length > 0 && accountId !== '') {
      if (hasGoBrain()) {
        processVideos(arrVideoEl);
      } else {
        loadScriptOnce(EXT_SCRIPT_URL, { isReady: hasGoBrain })
          .then(() => {
            processVideos(arrVideoEl);
          })
          .catch(() => {
            console.log('Qbrick error: Could not load script');
          });
      }
    }
  }

  function processVideos(arrVideoEl: any[]) {
    arrVideoEl.forEach((videoEl: any) => {
      // Skip elements that still have their player - only reprocess ones reset back to raw text
      if (videoEl.querySelector('qplayer-embed')) return;

      // Get media id and sharing/download settings from video snippet inner text
      const arrConfig = videoEl.innerText.replace(/\s+/g, '').split('#');
      const mediaId = arrConfig[0];
      const sharing = config.sharing || (arrConfig.length > 1 && parseInt(arrConfig[1], 10) === 1);
      const download = config.download || (arrConfig.length > 2 && parseInt(arrConfig[2], 10) === 1);
      const playerElement = createPlayerElement(mediaId, accountId, language, sharing, download, analytics);

      // Insert player element
      videoEl.innerHTML = '';
      videoEl.appendChild(playerElement);
    });
  }

  return {
    init,
  };
};

export default videoParser;
